import React from 'react';
import CheckSmsIcon from './CheckSmsIcon';

interface CheckBoxProps {
  showName: string
  check: (name: string, checked: boolean) => void
  savedShows: Array<String>
  formStep: number
}

function ShowCheckBox({
  check, formStep, savedShows, showName,
}: CheckBoxProps) {
  const isChecked = savedShows.includes(showName);
  return (
    <label htmlFor={showName} className="relative flex items-start space-x-1">
      <input
        type="checkbox"
        name={showName}
        disabled={formStep > 1}
        onChange={({ target }) => {
          check(target.name, !!target.checked);
        }}
        checked={isChecked}
        className="w-[16px] h-[16px] appearance-none border-chdGrey peer border rounded-[1.5px] shadow shadow-checkbox mr-1"
        id={showName}
      />
      <p className={`${isChecked ? 'text-darkCyan font-bold' : 'text-black'} capitalize leading-[18px]`}>{showName}</p>
      <CheckSmsIcon />
    </label>
  );
}
type ShowReminderCheckBoxProps = {
  currentShowList: string[]
  fullShowList: string[] | undefined
  handleCheckBox: (name: string, checked: boolean) => void
  savedShows: string[]
  formStep: number
}

function ShowReminderCheckBox({
  currentShowList,
  fullShowList,
  handleCheckBox,
  savedShows,
  formStep,
}: ShowReminderCheckBoxProps) {
  return (
    <div className="flex flex-col items-center w-full my-2">
      {!currentShowList.length ? (
        <div className="w-full text-center xs:w-2/3 sm:w-1/2">
          <span className="text-sm italic font-semibold text-darkCyan">
            Note: If no shows are selected and this form is submitted, this phone number will be unsubscribed from all shows.
          </span>
        </div>
      ) : (
        <div>
          <span className="text-sm italic font-semibold text-darkCyan ">
            You are signed up to receive updates  for
            {' '}
            {currentShowList.length}
            {' '}
            show
            {currentShowList.length > 1 ? 's' : ''}
            .
          </span>
        </div>
      )}
      {fullShowList && (
        <div className="grid self-start xs:self-auto mx-[10px] md:pl-[50px] mt-8 mb-5 text-left md:w-full gap-y-4 gap-x-20 md:grid-cols-2">
          {fullShowList.map((showName) => (
            <ShowCheckBox
              key={showName}
              showName={showName}
              check={(name, checked) => handleCheckBox(name, checked)}
              savedShows={savedShows}
              formStep={formStep}
            />
          ))}
        </div>
      )}
      {!fullShowList && <p>No shows found...</p>}
    </div>
  );
}

export default ShowReminderCheckBox;
